import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import { Seo } from 'components';
import './blog-materials.css';

const BlogMaterialsInner = ({ posts }) => {
  const materials = posts
    .map(({ node }) => node)
    .filter(p => p.frontmatter.collection === 'kak-u-drugih');

  return (
    <>
      <Seo
        title="Полезные материалы | Nimax"
        description="Бесплатные PDF-материалы от команды Nimax: гайды, чек-листы и шаблоны по маркетингу, SEO и рекламе."
        url="https://www.nimax.ru/blog/materials/"
      />

      <div className="mat-listing">

        {/* ── Header block ── */}
        <div className="mat-listing__header">
          <div className="mat-listing__header-meta">
            <span className="mat-listing__label">подборка</span>
            <span className="mat-listing__count">
              <strong>{materials.length}</strong> материалов
            </span>
          </div>
          <hr className="mat-listing__rule" />
          <h1 className="mat-listing__title">полезные материалы</h1>
        </div>

        <div className="mat-listing__grid">
          {materials.map(mat => (
            <article key={mat.fields.slug} className="mat-card">
              <Link to={mat.fields.uri} className="mat-card__img-wrap">
                {mat.frontmatter.cover_image && (
                  <img
                    src={mat.frontmatter.cover_image}
                    alt={mat.frontmatter.title}
                    loading="lazy"
                  />
                )}
              </Link>
              <div className="mat-card__body">
                <span className="mat-card__badge">ПОЛЕЗНЫЙ МАТЕРИАЛ</span>
                <Link to={mat.fields.uri} className="mat-card__title">
                  {mat.frontmatter.title}
                </Link>
                <a
                  href={mat.frontmatter.download_url || mat.fields.uri}
                  className="mat-card__btn"
                  download
                >
                  Скачать PDF
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default ({ pageContext = {} }) => (
  <StaticQuery
    query={graphql`
      query BlogMaterialsQuery {
        allMdx(
          filter: { fields: { category: { eq: "blog" } } }
          sort: { fields: [frontmatter___date], order: DESC }
        ) {
          edges {
            node {
              frontmatter {
                title
                cover_image
                collection
                download_url
              }
              fields {
                uri
                slug
              }
            }
          }
        }
      }
    `}
    render={({ allMdx: { edges: posts } }) => (
      <BlogMaterialsInner posts={posts} />
    )}
  />
);
